// extracted by mini-css-extract-plugin
export default {"root":"styles_root__7sosv","header":"styles_header__x1Icg"};